module.exports = __webpack_public_path__ + "assets/8ac7b156afa6538c655637ed3901521f.mp4";